
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class CustomersDialog extends Serenity.EntityDialog<CustomersRow, any> {
        protected getFormKey() { return CustomersForm.formKey; }
        protected getIdProperty() { return CustomersRow.idProperty; }
        protected getLocalTextPrefix() { return CustomersRow.localTextPrefix; }
        protected getNameProperty() { return CustomersRow.nameProperty; }
        protected getService() { return CustomersService.baseUrl; }
        protected getDeletePermission() { return CustomersRow.deletePermission; }
        protected getInsertPermission() { return CustomersRow.insertPermission; }
        protected getUpdatePermission() { return CustomersRow.updatePermission; }

        protected form = new CustomersForm(this.idPrefix);

        private customerAddressGrid: CustomerAddressGrid;
       
        private loadedState: string;

        constructor() {
            super();

            this.customerAddressGrid = new CustomerAddressGrid(this.byId("CustomerAddressGrid"));
            this.customerAddressGrid.element.flexHeightOnly(1);

        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        loadResponse(data) {
            super.loadResponse(data);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'CustomerAddress', this.isNewOrDeleted());

            this.loadedState = this.getSaveState();
        }

        loadEntity(entity: CustomersRow) {
            super.loadEntity(entity);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'CustomerAddress', this.isNewOrDeleted());

            this.customerAddressGrid.CustomerId = entity.Id;
            
        }


        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.customerAddressGrid.CustomerId = this.entityId;
           
        }

        protected validateBeforeSave() {
            var isValidate = super.validateForm();
            if (isValidate) {
                isValidate = super.validateBeforeSave();
            }
            //if (this.form.OrderProducts.rowCount() == 0) {
            //    Q.alert("At least one Product is mandatory for Order.");
            //    return false;
            //}
            return isValidate;
        }
    }
}